import React from 'react';

const cards = [
    {
        title: 'Beneficios exclusivos:',
        description: 'En alimentación, viajes, hoteles y servicios que hacen ',
        descriptionBold: 'tu vida más práctica.',
        image: '/assets/couple-fly.webp',
    },
    {
        title: 'Ahorra y descubre nuevas pasiones:',
        description: 'experiencias y descuentos para ',
        descriptionBold: 'más de 50 marcas aliadas',
        image: '/assets/family.webp',
    },
    {
        title: 'Un estilo de vida con propósito:',
        description: 'guías, entrevistas y artículos para crecer con ',
        descriptionBold: 'independencia, salud y diversión.',
        image: '/assets/couple.webp',
    },
    {
        title: 'Inspírate y reinvéntate:',
        description: 'planes para ',
        descriptionBold: 'romper la rutina y motivarte ',
        descriptionEnd: 'a cuidarte.',
        image: '/assets/Pareja2.webp',
    },
    {
        title: 'Juegos y trivias:',
        description: 'activa tu mente, reta tu agilidad ',
        descriptionBold: 'y sigue aprendiendo.',
        image: '/assets/Familia1.webp',
    },
];

const Carrusel: React.FC = () => {
    return (
        <section className='container_content_carrusel'>
            <h1 className='title_carrusel'>
                Vive un año lleno de experiencias pensadas en ti.
            </h1>                
            <div className="carousel-container">
                <div className="carousel-scroll-wrapper">
                    <div className="carousel-scroll">
                        {cards.map((card, index) => (
                        <div className="carousel-card" key={index}>
                            <div className='card_content'>
                                <h1 className='title_card'>{card.title}</h1>
                                <p className='text_card'>{card.description}
                                    <strong>{card.descriptionBold}</strong>
                                    {card.descriptionEnd}
                                </p>
                            </div>
                            <div className='card_image'>
                                <img className='img_carrusel' src={card.image} alt={card.title} />
                            </div>
                        </div>
                        ))}
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Carrusel;